import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex-grow flex overflow-hidden" }
const _hoisted_2 = { class: "flex-grow flex flex-col h-full relative" }
const _hoisted_3 = {
  key: 0,
  class: "min-h-300 absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Loading virtual mailbox...", -1)
const _hoisted_5 = {
  key: 0,
  class: "min-h-300 absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", { class: "p-4" }, " Virtual Mailbox ", -1)
const _hoisted_7 = { class: "flex flex-col pt-4 items-center justify-center relative w-full" }
const _hoisted_8 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4 bg-white bg-opacity-75 z-100"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Enabling virtual mailbox ", -1)
const _hoisted_10 = { class: "rounded-md bg-white shadow-lg px-5 py-8 w-3/4 flex flex-col gap-4" }
const _hoisted_11 = { class: "flex gap-4 items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Setup a virtual mailbox for all your mail, digitized. Have all your mail scanned and searchable in yout Thatch inbox, as well as delivered to your email. Remove paper headaches from your life ", -1)
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("header", { class: "p-4" }, " Virtual Mailbox ", -1)
const _hoisted_16 = { class: "flex flex-col pt-4 items-center justify-center relative" }
const _hoisted_17 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4 bg-white bg-opacity-75 z-100"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Enabling virtual mailbox ", -1)
const _hoisted_19 = { class: "rounded-md bg-white shadow-lg px-5 py-8 w-3/4 2xl:w-2/4 flex flex-col gap-4" }
const _hoisted_20 = { class: "flex gap-4 items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " Setup a virtual mailbox for all your mail, digitized. Have all your mail scanned and searchable in yout Thatch inbox, as well as delivered to your email. Remove paper headaches from your life ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, " Choose your location ", -1)
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = { class: "px-6 py-4 flex justify-between items-center border-0 border-b border-solid border-gray-200" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Virtual Mailboxes", -1)
const _hoisted_28 = { class: "flex gap-6" }
const _hoisted_29 = { class: "w-full flex flex-col gap-4" }
const _hoisted_30 = { class: "flex border-0 border-b border-gray-200 px-6 py-2" }
const _hoisted_31 = {
  key: 0,
  class: "w-1/4 flex-shrink-0"
}
const _hoisted_32 = {
  key: 0,
  class: "w-1/4 flex gap-4 flex-shrink-0"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["onMouseenter", "onMouseleave"]
const _hoisted_35 = {
  key: 1,
  class: "h-4 w-4 ml-2"
}
const _hoisted_36 = {
  key: 1,
  class: "text-center my-12"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " Your virtual mailbox system subscription is inactive ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " Go to current subscription to get more details ", -1)
const _hoisted_39 = {
  key: 1,
  class: "text-center my-12"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " You have no virtual mailbox system subscription ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " To start using virtual mailbox system purchase the subscription ", -1)
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"w-80 h-full border-solid border-0 border-l outline-none details-block flex flex-col gap-4 p-4 flex-shrink-0\"><p>Virtual Mailbox Overview</p><p class=\"text-13\"> Setup a virtual mailbox in one of our secure mail processing facilities. </p><ul class=\"text-13 list-disc pl-4\"><li class=\"mb-1\"> Mail is scanned within 24 hours of receipt (usually faster) </li><li class=\"mb-1\"> Set your team members that have access to this mailbox </li><li class=\"mb-1\"> Any mail can be selected for forwarding to your address of your choosing for a $1.50 fee + cost of shipping </li><li class=\"mb-1\"> Email notifications can be sent to the team when new mail arrives as either the full PDF or a link back to Thatch for more secure viewing </li></ul></div>", 1)

import {
	SvgIcon,
	UiButton,
	UiLoader,
	UiFormError
} from '@/ui-kit';
import { useToggle } from '@vueuse/shared';
import { ref, computed, reactive } from 'vue';
import { useVirtualMailbox } from '../use-virtual-mailbox';
import { useVirtualMailboxSystem } from '@/billing/use-virtual-mailbox-system';
import { useRouter } from 'vue-router';
import { AxiosError } from 'axios';
import { useBilling } from '@/billing';
import { Mailbox } from '../mailbox';
import { Mail } from '../mail';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualMailbox',
  setup(__props) {

const {
	isLoading,
	isEnabled,
	enableVirtualMailbox,
	locations,
	items
} = useVirtualMailbox();

const [loading, setLoading] = useToggle();
const [loadingItems, setLoadingItems] = useToggle();

const { isLoaded, getProductSettings } = useBilling();
const { isPaidAccount } = useCompanyProfile();

const selected = ref(0);

const error = ref('');

const onError = (e: AxiosError) => {
	if (!e.response || !e.response.data) {
		return;
	}

	if (e.response.data.error || e.response.data.message) {
		error.value =
			e.response.data.error ||
			e.response.data.message;
	}

	if (e.response.data.errors) {
		error.value =
			Object.values(
				e.response.data.errors as Record<
					string,
					string[]
				>
			)[0]?.[0] || '';
	}
};

async function enable() {
	setLoading(true);
	error.value = '';
	try {
		await enableVirtualMailbox();
	} catch (e) {
		onError(e as AxiosError);
	} finally {
		setLoading(false);
	}
}

const isLoadedAndEnabled = computed(
	() => !isLoading.value && isEnabled.value
);

const { hasVirtualMailboxSystem, isVirtualMailboxActive } =
	useVirtualMailboxSystem();

const router = useRouter();

function toPurchase() {
	return router.push({ name: 'AvailablePlans' });
}

function toSubscription() {
	return router.push({ name: 'CurrentSubscription' });
}

function isCurrentUsagePlanLimitReached(
	item?: Mailbox
): boolean {
	if (!item) {
		return false;
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return currentUsage >= productUsage;
}

function getItemUsage(item?: Mailbox): string {
	if (!item) {
		return '';
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return `<span class="${
		isCurrentUsagePlanLimitReached(item)
			? 'text-red-400'
			: ''
	} ">
		${currentUsage} </span> / ${productUsage} `;
}

const isHovered = reactive(new Set<number>());

function getLocation(item: Mailbox): string {
	return `${item.physical_location.line}, ${item.physical_location.city} ${item.physical_location.state} ${item.physical_location.zip}`;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isLoaded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(UiLoader))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(hasVirtualMailboxSystem))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(isVirtualMailboxActive))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(isLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("p", null, _toDisplayString(_unref(isLoading)
										? 'Loading virtual mailbox'
										: 'Loading mailboxed'), 1),
                              _createVNode(_unref(UiLoader))
                            ]))
                          : (!_unref(isEnabled))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_6,
                                _createElementVNode("div", _hoisted_7, [
                                  (_unref(loading))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _hoisted_9,
                                        _createVNode(_unref(UiLoader))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_unref(SvgIcon), {
                                        class: "h-10 w-10",
                                        name: "VirtualMailboxIcon"
                                      }),
                                      _hoisted_12
                                    ]),
                                    _hoisted_13,
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_unref(UiButton), {
                                        class: "!rounded-none",
                                        loading: 
												_unref(loading)
											,
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
												enable()
											))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Let's get started ")
                                        ]),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _createVNode(_unref(UiFormError), {
                                      class: "mt-4",
                                      errorMessage: 
											error.value
										
                                    }, null, 8, ["errorMessage"])
                                  ])
                                ])
                              ], 64))
                            : (!_unref(items).length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_15,
                                  _createElementVNode("div", _hoisted_16, [
                                    (_unref(loading))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          _hoisted_18,
                                          _createVNode(_unref(UiLoader))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_unref(SvgIcon), {
                                          class: "h-10 w-10",
                                          name: "VirtualMailboxIcon"
                                        }),
                                        _hoisted_21
                                      ]),
                                      _hoisted_22,
                                      _hoisted_23,
                                      _createElementVNode("div", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locations), (location) => {
                                          return (_openBlock(), _createBlock(_unref(UiButton), {
                                            theme: 
												selected.value ===
												location.id
													? 'dark'
													: 'dark-outlined'
											,
                                            class: _normalizeClass([
												'!rounded-none',
												{
													'opacity-50':
														selected.value !==
														location.id
												}
											]),
                                            onClick: ($event: any) => (
												selected.value =
													location.id
											),
                                            disabled: 
												_unref(loading)
											,
                                            key: 
												location.id
											
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(location.city) + ", " + _toDisplayString(location.state), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["theme", "class", "onClick", "disabled"]))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_RouterLink, {
                                          to: {
												name: 'AddVirtualMailbox',
												params: selected.value
													? {
															location:
																selected.value
													  }
													: {}
											}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(UiButton), {
                                              class: "!rounded-none",
                                              loading: 
													_unref(loading)
												,
                                              disabled: 
													!selected.value
												
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Add first virtual mailbox ")
                                              ]),
                                              _: 1
                                            }, 8, ["loading", "disabled"])
                                          ]),
                                          _: 1
                                        }, 8, ["to"])
                                      ])
                                    ])
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("header", _hoisted_26, [
                                    _hoisted_27,
                                    _createElementVNode("div", _hoisted_28, [
                                      _createVNode(_component_RouterLink, { to: {
											name: 'VirtualMailboxAddresses'
										} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(UiButton), {
                                            class: "!text-sm !h-8 !min-w-20 w-32 !px-0",
                                            theme: "transparent"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Shipping Addresses ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_RouterLink, { to: {
											name: 'AddVirtualMailbox'
										} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(UiButton), {
                                            class: "!text-sm !h-8 !min-w-20 w-32 !px-0",
                                            theme: "primary-outlined"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(SvgIcon), {
                                                class: "h-4 w-4 mr-2",
                                                name: "plus"
                                              }),
                                              _createTextVNode("Add mailbox ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex-shrink-0", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                      }, " Name ", 2),
                                      (_unref(isPaidAccount))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Current Usage "))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex-shrink-0", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                      }, " Address ", 2),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex-shrink-0", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                      }, " Access ", 2)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "flex text-sm mx-2 py-2 px-4 border border-solid border-gray-200 rounded-md",
                                        key: item.id
                                      }, [
                                        _createVNode(_component_RouterLink, {
                                          to: {
											name: 'EditVirtualMailbox',
											params: {
												id: item.id
											}
										},
                                          class: _normalizeClass(["flex-shrink-0 blue-link cursor-pointer", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.friendly_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "class"]),
                                        (_unref(isPaidAccount))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                              _createElementVNode("div", {
                                                innerHTML: 
												getItemUsage(
													item
												)
											
                                              }, null, 8, _hoisted_33),
                                              (
												isCurrentUsagePlanLimitReached(
													item
												)
											)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "group relative",
                                                    onMouseenter: ($event: any) => (
												isHovered.add(
													item.id
												)
											),
                                                    onMouseleave: ($event: any) => (
												isHovered.delete(
													item.id
												)
											)
                                                  }, [
                                                    _createVNode(_unref(SvgIcon), {
                                                      class: "h-4 w-4",
                                                      name: "info"
                                                    }),
                                                    _createElementVNode("button", {
                                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
													_ctx.$router.push(
														{
															name: 'CurrentSubscription'
														}
													)
												)),
                                                      class: _normalizeClass(["transition absolute -bottom-5 opacity-0 text-xs w-68 items-center underline cursor-pointer bg-white shadow-md py-1 px-2 -translate-x-1/2 transform group-hover:opacity-100", 
													isHovered.has(
														item.id
													)
														? 'z-10'
														: '-z-1'
												])
                                                    }, " Save funds by purchasing bigger volume plan ", 2)
                                                  ], 40, _hoisted_34))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_35))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex-shrink-0", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                        }, _toDisplayString(getLocation(
												item
											)), 3),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex-shrink-0", 
											_unref(isPaidAccount)
												? 'w-1/4'
												: 'w-1/3'
										])
                                        }, _toDisplayString(item.team_members
												.map(
													(m) =>
														m.name
												)
												.join(', ')), 3)
                                      ]))
                                    }), 128))
                                  ])
                                ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _hoisted_38,
                        _createVNode(_unref(UiButton), {
                          theme: "primary-outlined",
                          onClick: toSubscription,
                          class: "mt-6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SvgIcon), {
                              class: "mr-2 h-5 w-5",
                              name: "external-link"
                            }),
                            _createTextVNode(" To Subscription ")
                          ]),
                          _: 1
                        })
                      ]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _hoisted_41,
                  _createVNode(_unref(UiButton), {
                    theme: "primary-outlined",
                    onClick: toPurchase,
                    class: "mt-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SvgIcon), {
                        class: "mr-2 h-5 w-5",
                        name: "external-link"
                      }),
                      _createTextVNode(" To Purchase ")
                    ]),
                    _: 1
                  })
                ]))
          ], 64))
    ]),
    _hoisted_42
  ]))
}
}

})